import { useEffect, useState } from 'react';

export function PastScheduleWarning({ dates }: { dates: (string | null)[] }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 10_000);
    return () => window.clearInterval(timer);
  }, []);
  const count = dates.filter((date) => date && Date.parse(date) <= now).length;
  return count ? <div className="launch-schedule-warning" role="alert">
    <strong>Час запуску в минулому</strong>
    <span>Для {count} {count === 1 ? 'кампанії' : 'кампаній'} показ може початися одразу після створення реклами. Перевірте дату, час і часовий пояс.</span>
  </div> : null;
}
